<ng-container>
  <div class="filter-header">
    {{ 'Filters' | trans }}

    <btn
      class="filter-burger"
      [icon]="'burger'"
      [type]="'neutral'"
      (onClick)="onClick($event)"
    />
  </div>

  <form-group
    [name]="'post-filter'"
    [type]="formType"
    [data]="localData()"
    (onSubmit)="onSubmit($event)"
  >
    <form-row [target]="'categories'"/>

    <form-button
      [label]="'Filter'"
      [fullContent]="true"
    />
  </form-group>
</ng-container>
